module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/crocodile-english.dd35d6f2.jpg";